import { combineReducers } from "redux";
import liveChatReducer from "./liveChatReducer";
import { setLiveChatStateReducer } from "./setLiveChatStateReducer";


const chatReducer = combineReducers({
    livechat: liveChatReducer,
    livechatState: setLiveChatStateReducer

});

export default chatReducer;